import type { ReactNode } from "react";

interface FieldWrapperProps {
  label?: string;
  helper?: string;
  error?: string;
  required?: boolean;
  htmlFor?: string;
  children: ReactNode;
}

export function FieldWrapper({
  label,
  helper,
  error,
  required,
  htmlFor,
  children,
}: FieldWrapperProps) {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={htmlFor}
          className="mb-1.5 block text-[13px] font-medium text-ink-secondary"
        >
          {label}
          {required && <span className="ml-0.5 text-danger">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <p className="mt-1 text-xs text-danger">{error}</p>
      ) : helper ? (
        <p className="mt-1 text-xs text-ink-muted">{helper}</p>
      ) : null}
    </div>
  );
}